import { axiosClient } from "@/api/axios";

export async function getCourses(semesterId, activeRole) {
  return axiosClient.get(`team/${semesterId}/${activeRole}/courses`);
}

export async function getStudents(semesterId, activeRole) {
  return axiosClient.get(`team/${semesterId}/${activeRole}/students`);
}

export async function getTeachers(semesterId, activeRole) {
  return axiosClient.get(`team/${semesterId}/${activeRole}/teachers`);
}
